import { createAction } from 'redux-actions';
import { push } from 'react-router-redux';
import { openGlobalModal } from 'actions/modal';
import { toggleLoading } from 'actions/global';

import { wrapFetch, wrapFetchAuth } from './endpoint';

export const getCourseList = createAction('GET_COURSE_LIST', () => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetch('api/web/course', {
		method: 'GET',
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		return {
			list: {
				come: data.coming_soon,
				apply: data.now_applying,
				past: data.past,
			},
		};
	}
	return { };
});

export const getMemberCourseList = createAction('GET_MEMBER_COURSE_LIST', () => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetchAuth('api/web/user/course', {
		method: 'GET',
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		return {
			memberCourse: {
				come: data.coming_soon,
				past: data.past,
			},
		};
	}
	return {};
});

export const getCourseInfo = createAction('GET_COURSE_INFO', id => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetch(`api/web/course/${id}`, {
		method: 'GET',
	});

	dispatch(toggleLoading(false));
	if (status === 200) {
		return {
			info: data,
			inputFlash: data.input_flash_number,
			inputLens: data.input_lens_number,
			inputSeries: data.input_series_number,
			teacher: data.teacher,
			courseId: id,
		};
	}
	return {};
});

export const defaultCourseInfo = createAction('DEFAULT_COURSE_INFO', () => ({
	info: [],
	teacher: [],
	courseId: '',
}));

export const courseSignup = createAction('COURSE_SIGNUP', (course, user, name, mobile, type, coupon, remarks, series, flash, lens) => async dispatch => {
	const data = JSON.stringify({
		course_id: course,
		user_id: user,
		name,
		mobile,
		payment_type: type,
		coupon,
		remarks,
		series_number: series,
		flash_number: flash,
		lens_number: lens,
	});

	dispatch(toggleLoading(true));

	const result = await wrapFetchAuth('api/web/course/signUpForm', {
		method: 'POST',
		body: data,
	});

	dispatch(toggleLoading(false));

	if (result.status === 200 || result.status === 201) {
		dispatch(push(`/course/${course}/result?status=SUCCESS`));
	} else if (result.status === 400) {
		dispatch(push(`/course/${course}/result?status=FAIL`));
	}
	return {};
});

export const courseSignupFree = createAction('COURSE_SIGNUP_FREE', (course, user, name, mobile, type, remarks, series, flash, lens) => async dispatch => {
	const data = JSON.stringify({
		course_id: course,
		user_id: user,
		name,
		mobile,
		payment_type: type,
		remarks,
		series_number: series,
		flash_number: flash,
		lens_number: lens,
	});

	dispatch(toggleLoading(true));

	const result = await wrapFetchAuth('api/web/course/signUpForm', {
		method: 'POST',
		body: data,
	});

	dispatch(toggleLoading(false));

	if (result.status === 200 || result.status === 201) {
		dispatch(push(`/course/${course}/result?status=SUCCESS`));
	} else if (result.status === 400) {
		dispatch(push(`/course/${course}/result?status=FAIL`));
	}
	return {};
});

export const courseSignupLinePay = createAction('COURSE_SIGNUP_LINEPAY', (course, user, name, mobile, type, remarks, invoiceType, invoiceData, tax, series, flash, lens) => async dispatch => {
	const data = JSON.stringify({
		course_id: course,
		user_id: user,
		name,
		mobile,
		payment_type: type,
		remarks,
		invoice_type: invoiceType,
		invoice_data: invoiceData,
		tax_id_number: tax,
		series_number: series,
		flash_number: flash,
		lens_number: lens,
	});
	dispatch(toggleLoading(true));

	const result = await wrapFetchAuth('api/web/course/signUpForm', {
		method: 'POST',
		body: data,
	});
	dispatch(toggleLoading(false));
	window.location.href = result.paymentUrl.web;
});

export const getCourseRecommend = createAction('GET_COURSE_RECOMMEND', id => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetchAuth(`api/web/course/${id}/recommend`, {
		method: 'GET',
	});

	dispatch(toggleLoading(false));

	if (status === 200) {
		return {
			recommend: data,
		};
	}
	return {};
});

export const courseCancel = createAction('COURSE_CANCEL', (id, reason) => async dispatch => {
	dispatch(toggleLoading(true));
	const result = await wrapFetchAuth('api/web/course/cancel', {
		method: 'POST',
		body: JSON.stringify({ course_id: id, cancel_reason: reason }),
	});
	dispatch(toggleLoading(false));

	if (result.status === 200) {
		dispatch(push(`/membercourse/${id}/result?status=SUCCESS`));
	} else if (result.status === 400) {
		dispatch(push(`/membercourse/${id}/result?status=FAIL`));
	}
	return {};
});

export const courseATMCancel = createAction('COURSE_ATM_CANCEL', (id, reason, bank, branch, account, name) => async dispatch => {
	dispatch(toggleLoading(true));
	const result = await wrapFetchAuth('api/web/course/cancel', {
		method: 'POST',
		body: JSON.stringify({
			course_id: id,
			cancel_reason: reason,
			ATM_refund_bank_code: bank,
			ATM_refund_branch_code: branch,
			ATM_refund_bank_account: account,
			ATM_refund_name: name,
		}),
	});
	dispatch(toggleLoading(false));

	if (result.status === 200) {
		dispatch(push(`/membercourse/${id}/result?status=SUCCESS`));
	} else if (result.status === 400) {
		dispatch(push(`/membercourse/${id}/result?status=FAIL`));
	}
	return {};
});


export const checkHaveProduct = createAction('CHECK_HAVE_PRODUCT', () => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetchAuth('api/web/user/product', {
		method: 'GET',
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		if (data.length === 0) {
			dispatch(openGlobalModal('courseSignupNeedAddProduct'));
		}
	}
});

export const checkCourseTheme = createAction('CHECK_COURSE_THEME', id => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetchAuth(`api/web/course/${id}`, {
		method: 'GET',
	});

	dispatch(toggleLoading(false));

	if (status === 200) {
		if (data.theme === 'BASIC' || data.theme === 'HIGH_LEVEL') {
			dispatch(checkHaveProduct());
		}
	}
});



// WEBPACK FOOTER //
// ./src/actions/course.js